import { ScrollArea as ScrollAreaPrimitive } from '@base-ui/react/scroll-area';

import { cn } from '@/lib/utils';

function ScrollArea({
  className,
  children,
  ...props
}: ScrollAreaPrimitive.Root.Props) {
  return (
    <ScrollAreaPrimitive.Root
      data-slot="scroll-area"
      className={cn('group/scroll relative overflow-hidden', className)}
      {...props}
    >
      <ScrollAreaPrimitive.Viewport
        data-slot="scroll-area-viewport"
        className="focus-visible:ring-ring/50 size-full rounded-[inherit] outline-none focus-visible:ring-[3px] focus-visible:outline-1"
      >
        <ScrollAreaPrimitive.Content data-slot="scroll-area-content">
          {children}
        </ScrollAreaPrimitive.Content>
      </ScrollAreaPrimitive.Viewport>
      <ScrollBar orientation="vertical" />
      <ScrollAreaPrimitive.Corner />
    </ScrollAreaPrimitive.Root>
  );
}

function ScrollBar({
  className,
  orientation = 'horizontal',
  ...props
}: ScrollAreaPrimitive.Scrollbar.Props) {
  return (
    <ScrollAreaPrimitive.Scrollbar
      data-slot="scroll-area-scrollbar"
      data-orientation={orientation}
      orientation={orientation}
      className={cn(
        'data-[orientation=horizontal]:h-4 data-[orientation=horizontal]:flex-col data-[orientation=vertical]:w-4 flex touch-none p-1 transition-opacity duration-(--duration-fast) ease-standard motion-reduce:transition-none select-none opacity-0 hover:opacity-100 data-hovering:opacity-100 data-scrolling:opacity-100 group-focus-within/scroll:opacity-100',
        className,
      )}
      {...props}
    >
      <ScrollAreaPrimitive.Thumb
        data-slot="scroll-area-thumb"
        className="rounded-full bg-border hover:bg-muted-foreground relative flex-1 transition-colors duration-(--duration-fast) ease-standard motion-reduce:transition-none"
      />
    </ScrollAreaPrimitive.Scrollbar>
  );
}

ScrollArea.displayName = 'ScrollArea';
ScrollBar.displayName = 'ScrollBar';

export { ScrollArea, ScrollBar };
